import { useQuery, useMutation } from "react-query";
import {
	getMenuItems_api,
	syncMenuItems_api,
	syncLunchboxImages_api,
} from "../services/menuItems";

export const useGetMenuItems = (body) =>
	useQuery(["getMenuItems", body], () => getMenuItems_api(body));

export const useSyncMenuItems = () =>
	useMutation((restaurantId) => syncMenuItems_api(restaurantId));

export const useSyncLunchboxImages = () =>
	useMutation((restaurantId) => syncLunchboxImages_api(restaurantId));
